import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import IncidentTable from "components/incident/IncidentTable";
import Container from "components/layout/Container";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Incident: React.FC = () => {
  const { t } = useTranslation("incident");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle" component="h1">
            {t("title")}
          </HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <IncidentTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const IncidentAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasModulePolicy(
      ModuleNames.incidentManagement,
      ModulePolicyTypes.incident
    );
  }, [hasModulePolicy]);
  return (
    <>
      {hasRight ? (
        <Container noHVContainer>
          <Incident />
        </Container>
      ) : (
        <NotFound />
      )}
    </>
  );
};
export default Incident;
